import { render, staticRenderFns } from "./StudyNewPage.vue?vue&type=template&id=21b95d77&scoped=true"
import script from "./StudyNewPage.vue?vue&type=script&lang=js"
export * from "./StudyNewPage.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPage.vue?vue&type=style&index=0&id=21b95d77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b95d77",
  null
  
)

export default component.exports